export const tourText = {
  workspaceName: {
    title: 'Workspace name',
    description:
      'Set how your workspace is identified across tapybl. Up to 40 characters.',
  },
  workspaceLogo: {
    title: 'Workspace logo',
    description:
      'Upload a square image used as your workspace avatar. PNG or JPG work best.',
  },
  workspacePrimaryColor: {
    title: 'Primary color',
    description:
      'Pick the main brand color that is applied to buttons and key UI accents.',
  },
  workspaceSecondaryColor: {
    title: 'Secondary color',
    description:
      'Pick a complementary brand color used for secondary highlights and accents.',
  },
  llmProvider: {
    title: 'LLM provider',
    description:
      'Choose which AI provider powers content generation in this workspace.',
  },
};
